import React from 'react';
import { PageHeader } from '../components/page/PageHeader';
import { FeatureRow } from '../components/page/FeatureRow';
import { CtaBand } from '../components/page/CtaBand';
import { PlayCircle } from 'lucide-react';
import { Counter } from '../components/ui/Counter';
import { Reveal } from '../components/ui/Reveal';
import { LayeredPartnerRosterMockup, LayeredAListWedgeMockup, LayeredAgencyOutreachMockup } from '../components/page/MarketingMockups';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
const DEMO_VIDEO_URL = 'https://www.youtube.com/watch?v=U2sV81k41u4&pp=0gcJCUwLAYcqIYzv';
export const ForMarketingAgencies = () => {
  return <>
      <PageHeader eyebrow="For Marketing Agencies" eyebrowClass="bg-purple-50 text-purple-700 border border-purple-200" title="Keep your talent agency partners front and center" subtitle="Zano makes it easy and quick to keep the talent agency rosters you already partner with in front of you for quick reference when building campaigns. Plus, always keep in touch with the newest talent agencies." primaryCta={{
      label: 'Start Free Trial',
      to: '/pricing'
    }} secondaryCta={{
      label: 'Watch demo video',
      href: DEMO_VIDEO_URL,
      newTab: true,
      icon: <PlayCircle size={18} className="mr-1.5" data-id="element-1823" />
    }} data-id="element-1822" />

      {/* Metrics strip */}
      <section className="border-y border-gray-100 bg-gray-50/60 py-10" data-id="element-1824">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-1825">
          {[{
          v: <Counter to={400} suffix="+" data-id="element-1826" />,
          l: 'Talent agencies'
        }, {
          v: <Counter to={6000} suffix="+" data-id="element-1827" />,
          l: 'Represented creators'
        }, {
          v: <Counter to={100} suffix="" data-id="element-1828" />,
          l: 'Avg submissions / 24h'
        }, {
          v: <Counter to={500} prefix="$" suffix="k+" data-id="element-1829" />,
          l: 'GMV generated'
        }].map((s, i) => <Reveal key={i} delay={i * 0.08} data-id="element-1830">
              <p className="text-3xl font-bold text-zano-pink" data-id="element-1831">{s.v}</p>
              <p className="text-sm text-gray-600 mt-1" data-id="element-1832">{s.l}</p>
            </Reveal>)}
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 divide-y divide-gray-100" data-id="element-1833">
        <FeatureRow eyebrow="Partner Management" title="Keep partner rosters accessible" body="Already work with top talent agencies? Keep track of their live rosters on Zano instead of asking for updated PDFs every month. Quickly reference them when building campaigns for clients so you can move fast." bullets={['Filter the database by specific talent agencies', 'Always see their most up-to-date roster', 'Move faster on quick-turnaround client campaigns']} visual={<LayeredPartnerRosterMockup data-id="element-1835" />} data-id="element-1834" />
        <FeatureRow eyebrow="The Wedge" title="A-list access for your brand clients" body="Access to A-list talent gives your agency a powerful wedge for your brand clients. Suddenly, you know exactly how to get in touch with the highest level of creators and have direct contact with their talent managers." bullets={['Direct access to talent managers for top creators', 'Impress clients with premium talent options', 'No more guessing who represents who']} visual={<LayeredAListWedgeMockup data-id="element-1837" />} flip data-id="element-1836" />
        <FeatureRow eyebrow="Direct Outreach" title="Partner directly on deals" body="The talent agencies on Zano are here to get more brand deals for their talent, so they are happy to partner with you for your brand clients. Approach them directly by email or post a casting call to get custom submissions." bullets={['Direct email contact info for talent managers', 'Post casting calls to receive custom quotes', 'Build long-term relationships with top agencies']} visual={<LayeredAgencyOutreachMockup data-id="element-1839" />} data-id="element-1838" />
      </div>

      <Testimonials title="What marketing agencies are saying" items={BRAND_TESTIMONIALS} data-id="element-1840" />

      <CtaBand title="Build client campaigns faster" subtitle="Join the marketing agencies using Zano to keep their talent partners close." primaryCta={{
      label: 'Start Free Trial',
      to: '/pricing'
    }} secondaryCta={{
      label: 'Watch demo video',
      href: DEMO_VIDEO_URL,
      newTab: true,
      icon: <PlayCircle size={18} className="mr-1.5" data-id="element-1842" />
    }} data-id="element-1841" />
    </>;
};